import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetRoles({ teamId }: { teamId: string }) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/team/roles`, {
      headers: {
        'X-Team': teamId,
      },
    })

    return response.data
  }

  return useQuery({
    queryKey: ['roles', teamId],
    queryFn: fetchData,
    staleTime: Infinity,
  })
}
